module.exports = __webpack_public_path__ + "img/labBg4.5ff0bad1.png";